{
  "postTrading": {
    "info": {
      "titles": {
        "OPEXP": "Истечение опциона",
        "OPEXC": "Исполнение опциона",
        "OPASN": "Расчет обязательств"
      },
      "status": "Статус",
      "date": "Дата",
      "ticker": "Тикер",
      "qtyContracts": "Кол-во контрактов",
      "side": "Сторона сделки",
      "asset": "Актив",
      "qty": "Количество",
      "price": "Цена",
      "sum": "Сумма",
      "completed": "Завершено",
      "sides": {
        "call": "Покупка",
        "put": "Продажа"
      },
      "assetsInfoFailed": "Не удалось получить информацию об акции опциона"
    }
  }
}
